import React, { useEffect, useState } from 'react';
import { Card, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { recaptchaSiteKey } from '../../../Domain/Settings/Keys/Keys';
import {
  REGISTER_USER_PATH,
  API_CODE_VERIFICATION,
  FRONTEND_URL
} from '../../../Domain/Redux/Paths';
import { SimpleModalLT } from '../../Modals/SimpleModalLT/SimpleModalLT';
import { InputFormControl } from '../../Atoms/InputFormControl/InputFormControl';
import { SelectFormControl } from '../../Atoms/SelectFormControl/SelectFormControl';
import './InterestBrochureForm.css';
import Spinner from '../../Atoms/Spinner/Spinner';
import { useGetIdLanguage } from '../../../Core/Hooks/HookLanguageSelector/useGetIdLnaguage';
import { UNDEFINED_PLATFORM } from '../../../Domain/Settings/Constants/Constants';
import MessageError from '../../Atoms/MessageError/MessageError';
import AccountVerification from '../AccountVerification/AccountVerification';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { useCountries } from '../../../Core/Hooks/HookGetCountries/useCountriesList';

// @see https://react-select.com/home#custom-styles
const selectStyles = {
  control: (styles) => ({
    ...styles,
    border: 'none',
    borderBottom: '1px solid #ced4da'
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    // aquí defines tu propio color de fondo
    backgroundColor: isSelected
      ? '#f2f2f2' // fondo cuando el item está seleccionado
      : isFocused
      ? '#f5f5f5' // fondo cuando lo pasas por encima (hover)
      : 'white', // fondo normal
    color: 'black' // texto siempre negro
  }),
  singleValue: (styles) => ({
    ...styles,
    color: '#000'
  })
};

export const InterestBrochureForm = ({ interestData = {}, setLoader = () => {}, parameters }) => {
  const [errorCountry, setErrorCountry] = useState(false);
  const [dataForm, setDataForm] = useState({});
  const [isActiveModal, setIsActiveModal] = useState(false);
  const [errorPhoneType, setErrorPhoneType] = useState(false);

  const [modalData, setModalData] = useState({
    title: '',
    message: '',
    show: false
  });

  const language = useGetIdLanguage();
  const { countriesList, alpha2codeCountries, phoneTypeList } = useCountries();

  const {
    handleSubmit,
    errors,
    control,
    reset: resetForm,
    watch,
    getValues,
    setValue
  } = useForm({ mode: 'onChange' });
  const platform = sessionStorage.getItem('utm_source');

  useEffect(() => {
    if (!parameters?.PHONE_TYPE_DEFAULT?.value || phoneTypeList?.length === 0) return;

    const phoneTypeSelect = phoneTypeList?.find(
      (phone) => phone.id === Number(parameters?.PHONE_TYPE_DEFAULT?.value)
    );
    setValue('phone_type', phoneTypeSelect);
  }, [parameters, phoneTypeList]);

  const closeModal = () => {
    setErrorCountry(false);
    setModalData({
      ...modalData,
      show: false
    });
  };

  const handleWhatsAppRedirect = () => {
    // Obtenemos el número y el mensaje desde el estado del modal
    const phoneNumber = modalData.whatsAppNumber?.replace(/\D/g, '') || '';
    const message = encodeURIComponent(modalData.whatsAppMessage || '');

    if (phoneNumber) {
      const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
      // Abrimos el enlace en una nueva pestaña
      window.open(whatsappLink, '_blank', 'noopener,noreferrer');
    }
    // Cerramos el modal después de la acción
    closeModal();
  };

  const sendCodeVerification = async (data) => {
    setErrorCountry(false);
    const country = getValues('country');
    if (!data?.country?.pk) {
      setErrorCountry(true);
      return;
    }

    if (!data?.phone_type.id) {
      setErrorPhoneType(true);
      return;
    }

    setDataForm(data);
    setLoader(true);
    const sendCode = await HttpClient.POST(API_CODE_VERIFICATION, {
      email: data.email,
      multilanguageId: language
    });
    if (sendCode?.content) {
      setLoader(false);
      setIsActiveModal(true);
    }
  };

  const onSubmit = (values) => {
    setErrorCountry(false);

    if (!dataForm?.country?.pk) {
      setErrorCountry(true);
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptchaSiteKey, { action: 'homepage' }).then(async (token) => {
        setLoader(true);
        localStorage.setItem('reCaptcha', token);
        const data = {
          email: dataForm.email,
          name: dataForm.name,
          country_id: dataForm.country.pk ?? dataForm.country.id,
          phone_number: dataForm.phone,
          country_code_id: dataForm.phone_code?.pk ?? dataForm.phone_code?.id ?? null,
          information_interest: interestData?.name,
          advertising_platform: platform ?? UNDEFINED_PLATFORM,
          component: COMPONENTS.COUNTRY,
          multilanguage_id: language,
          phone_type: dataForm?.phone_type?.id
        };

        try {
          setIsActiveModal(false);
          const res = await HttpClient.POST(REGISTER_USER_PATH, data);

          setModalData({
            ...modalData,
            title: parameters?.TITLE_FROM_INSCRIPTION?.value || 'Registro exitoso',
            message:
              parameters?.TITLE_FROM_INSCRIPTION?.description_value ||
              'Para mas informacion puedes ponerte en contacto con uno de nuestros asesores',
            show: true,
            success: true,
            warning: false,
            isWhatsAppRedirect: true, // Una bandera para saber que es un modal de WhatsApp
            // Aquí debes poner el número de contacto de WhatsApp. Puede venir de `parameters` o ser un valor fijo.
            whatsAppNumber: parameters?.FIL_WHATSAPP?.value || '15624166771', // ¡IMPORTANTE! Reemplaza esto con tu número real
            whatsAppMessage:
              parameters?.MESSAGE_WHATAPP?.value ||
              'Hola, me registré en la web y quisiera más información.'
          });
          resetForm();
          setErrorCountry(false);
        } catch (error) {
          console.debug('>>>> InterestRegisterForm.onSubmit: error=', error);
          setModalData({
            ...modalData,
            title: parameters?.INF_MSG_54?.value || 'Error',
            message:
              parameters?.INF_MSG_55?.value ||
              'El registro no se completó debido a un error inesperado. Vuelva a intentarlo más tarde.',
            show: true,
            success: false,
            warning: true
          });
        } finally {
          setLoader(false);
        }
      });
    });
  };

  //Modal ok change parameters
  return (
    <>
      {modalData.show && (
        <SimpleModalLT
          show={modalData.show}
          title={modalData.title}
          subtitle={modalData.message}
          success={modalData.success}
          warning={modalData.warning}
          closeModal={closeModal}
          btnAction={modalData.isWhatsAppRedirect ? handleWhatsAppRedirect : null}
          btnCloseText={modalData.isWhatsAppRedirect ? parameters?.BOTON_WHATSAPP?.value : 'Whatsapp'}
          bgImage={false}
        />
      )}
      <Card className="border-0" style={{ borderRadius: '0' }}>
        <Card.Body className="p-0">
          {isActiveModal ? (
            <div
              style={{ margin: window.innerWidth < 600 ? '0 20px' : '0 60px', marginTop: '20px' }}>
              <AccountVerification
                showTitle
                email={dataForm?.email}
                onCloseModal={setIsActiveModal}
                onFinish={onSubmit}
              />
            </div>
          ) : (
            <Form
              className="form-register-interest"
              onSubmit={handleSubmit(sendCodeVerification)}
              id="brochure-form">
              <div className="px-4 py-2">
                <legend
                  className="w-100 text-center mb-1"
                  // * parameter code: FOOTER_CNU
                >
                  {parameters?.FOOTER_CNU?.value || <Spinner backgroundColor="black"></Spinner>}
                </legend>
                <Form.Group className="mb-0">
                  <InputFormControl
                    name="information_interest"
                    control={control}
                    type="hidden"
                    defaultValue={interestData?.name}
                  />
                </Form.Group>
                <Form.Group className="my-0 mt-2">
                  {watch('name')?.length > 0 && (
                    <label
                      style={{ color: '#aaa', fontSize: '11px' }}
                      className="description-label"
                      htmlFor="name"
                      // * parameter code: PH_MSG_1
                    >
                      {parameters?.PH_MSG_1?.value || 'Nombres y apellidos *'}
                    </label>
                  )}
                  {parameters?.PH_MSG_1?.value ? (
                    <InputFormControl
                      name="name"
                      control={control}
                      type="text"
                      // * parameter code: RQD_MSG_1
                      rules={{
                        required: parameters?.RQD_MSG_1?.value || 'El campo de nombre es requerido.'
                      }}
                      // * parameter code: PH_MSG_1
                      placeholder={parameters?.PH_MSG_1?.value}
                      error={errors?.name}
                    />
                  ) : (
                    <p>
                      <Spinner backgroundColor="black"></Spinner>
                    </p>
                  )}
                </Form.Group>
                <Form.Group className="my-0 mt-2">
                  {watch('email')?.length > 0 && (
                    <label
                      className="description-label"
                      htmlFor="email"
                      style={{ color: '#aaa', fontSize: '11px' }}
                      // * parameter code: PH_MSG_2
                    >
                      {parameters?.PH_MSG_2?.value || <Spinner backgroundColor="black"></Spinner>}
                    </label>
                  )}
                  {parameters?.PH_MSG_2?.value ? (
                    <InputFormControl
                      name="email"
                      control={control}
                      type="email"
                      rules={{
                        // * parameter code: RQD_MSG_2
                        required:
                          parameters?.RQD_MSG_2?.value || 'El campo de correo es requerido.',
                        pattern: {
                          value:
                            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          // * parameter code: ERR_MSG_2
                          message: parameters?.ERR_MSG_2?.value || 'Correo inválido.'
                        }
                      }}
                      // * parameter code: PH_MSG_2
                      placeholder={parameters?.PH_MSG_2?.value}
                      error={errors?.email}
                    />
                  ) : (
                    <p>
                      <Spinner backgroundColor="black"></Spinner>
                    </p>
                  )}
                </Form.Group>
                <Form.Group className="my-0 mt-2">
                  <div className="row" style={{ alignItems: 'flex-end' }}>
                    <Col xs={6} lg={5}>
                      {parameters?.PH_MSG_3?.value ? (
                        <SelectFormControl
                          name="phone_code"
                          control={control}
                          defaultValue={{
                            flag: 'https://static.litethinking.com/static/flag_country/co.png',
                            value: 'Colombia',
                            abbreviation_name: 'co',
                            dial_code: '+57',
                            pk: 35
                          }}
                          options={alpha2codeCountries}
                          nameOptionValue="abbreviation_name"
                          // * parameter code: RQD_MSG_3
                          rules={{
                            required: parameters?.RQD_MSG_3?.value || 'El campo es requerido.'
                          }}
                          error={errors?.dial_code}
                          renderOptionLabel={(option) => (
                            <>
                              <img
                                src={option?.flag}
                                aria-label={'Country flag'}
                                alt="Country flag"
                                style={{ width: 20, heigth: 16, marginRight: 5 }}
                              />
                              {`${option?.abbreviation_name} ${option?.dial_code}`.toUpperCase()}
                            </>
                          )}
                          // * parameter code: PH_MSG_3
                          placeholder={parameters?.PH_MSG_3?.value}
                          selectStyles={selectStyles}
                        />
                      ) : (
                        <p>
                          <Spinner backgroundColor="black"></Spinner>
                        </p>
                      )}
                    </Col>
                    <Col xs={6} lg={7} className="pl-0">
                      {watch('phone') !== '' && (
                        <label
                          className="description-label"
                          htmlFor="phone"
                          style={{ color: '#aaa', fontSize: '11px' }}
                          // * parameter code: PH_MSG_5
                        >
                          {parameters?.PH_MSG_5?.value || (
                            <Spinner backgroundColor="black"></Spinner>
                          )}
                        </label>
                      )}
                      {parameters?.PH_MSG_5?.value ? (
                        <InputFormControl
                          name="phone"
                          control={control}
                          type="number"
                          rules={{
                            // * parameter code: RQD_MSG_3
                            required: parameters?.RQD_MSG_3?.value || 'El campo es requerido',
                            pattern: {
                              value: /^[0-9]+$/,
                              // * parameter code: ERR_MSG_3
                              message: parameters?.ERR_MSG_3?.value || 'Únicamente números'
                            }
                          }}
                          // * parameter code: PH_MSG_5
                          placeholder={parameters?.PH_MSG_5?.value}
                          error={errors?.phone}
                        />
                      ) : (
                        <p>
                          <Spinner backgroundColor="black"></Spinner>
                        </p>
                      )}
                    </Col>
                    <Col xs={12} lg={12}>
                      {(watch('phone_type')?.id || watch('phone_type')?.pk) && (
                        <label style={{ color: '#aaa', fontSize: '11px' }} className="description-label" htmlFor="phone_type">
                          {parameters?.PHONE_TYPE_LABEL?.value || (
                            <Spinner backgroundColor="black"></Spinner>
                          )}
                        </label>
                      )}
                      <SelectFormControl
                        name="phone_type"
                        control={control}
                        options={phoneTypeList}
                        nameOptionValue="id"
                        rules={{
                          required: parameters?.RQD_MSG_3?.value || 'El campo es requerido.'
                        }}
                        error={errors?.phone_type}
                        renderOptionLabel={(option) => option.name}
                        placeholder={parameters?.PH_MSG_3?.value}
                        selectStyles={selectStyles}
                      />
                    </Col>
                    {errorPhoneType && <MessageError message={parameters?.RQD_MSG_3?.value} />}
                  </div>
                </Form.Group>
                <Form.Group className="my-0 mt-2">
                  <label
                    style={{ color: '#aaa', fontSize: '11px' }}
                    className="description-label"
                    htmlFor="country">
                    {watch('country') &&
                      (parameters?.PH_MSG_6?.value || <Spinner backgroundColor="black"></Spinner>)}
                  </label>

                  {parameters?.PH_MSG_7?.value ? (
                    <SelectFormControl
                      ariaLabel="Select your country"
                      name="country"
                      control={control}
                      options={countriesList}
                      nameOptionValue="name"
                      rules={{
                        required: parameters?.RQD_MSG_3?.value || (
                          <Spinner backgroundColor="black"></Spinner>
                        )
                      }}
                      error={errors?.country}
                      renderOptionLabel={(option) => option.name}
                      placeholder={'parameters?.PH_MSG_7?.value'}
                      selectStyles={selectStyles}
                    />
                  ) : (
                    <p>
                      <Spinner backgroundColor="black"></Spinner>
                    </p>
                  )}
                  {errorCountry && <MessageError message={parameters?.RQD_MSG_3?.value} />}
                </Form.Group>
                {errorCountry && <MessageError message={parameters?.RQD_MSG_3?.value} />}
              </div>
              <p
                style={{
                  textAlign: 'center',
                  width: '100%',
                  marginTop: '1rem',
                  fontSize: '14px',
                  color: 'rgb(153, 153, 153)'
                }}>
                {parameters?.INF_MSG_3?.value?.split('-')[0] || ''}
                <a
                  title="Términos de uso"
                  aria-label="Terminos de uso"
                  style={{ color: 'black', fontWeight: 'bold', textDecoration: 'none' }}
                  href={`${FRONTEND_URL}/policies-of-usage`}>
                  {parameters?.INF_MSG_3?.value?.split('-')[1] || ''}
                </a>{' '}
                {parameters?.INF_MSG_3?.value?.split('-')[2] || ''}
                <a
                  title="Política de privacidad"
                  aria-label="Politica de privacidad"
                  style={{ color: 'black', fontWeight: 'bold', textDecoration: 'none' }}
                  href={`${FRONTEND_URL}/privacity-policies`}>
                  {parameters?.INF_MSG_3?.value?.split('-')[3] || ''}
                </a>{' '}
                {parameters?.INF_MSG_3?.value?.split('-')[4] || ''}
              </p>
              <button
                type="submit"
                className="btn btn-submit yellow"
                disabled={Object.values(errors).length}
                // * parameter code: INF_MSG_56
              >
                {parameters?.INF_MSG_56?.value || <Spinner backgroundColor="black"></Spinner>}
              </button>
            </Form>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
